























































































































































































































































































































































































































import { Component, Mixins, Prop, Provide, Vue } from 'vue-property-decorator'
import {
  jzdx,
  yqxyy,
  SongGuo,
  ad,
  ResourceType,
  GR,
  weMedia,
  qk
} from '../../../../../service/common'
import { Task, TaskInstance, History } from '../../../types/task'
import { ConstantMixin } from '../ConstantMixin'

@Component
export default class AuditInfoItem extends Mixins(ConstantMixin) {
  @Prop() public data!: any
  @Prop() public parentInstance!: TaskInstance
  public urlReg = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/
  private get displayTaskName() {
    return this.data && this.data.name
  }

  private get displayUser() {
    if (!this.data || !this.data.auditor_name) return ''
    return this.data.auditor_name
  }

  private get displayResult() {
    if (!this.data || !this.data.approve_result_text) return ''
    return this.data.approve_result_text
  }

  private get isJzdxReject() {
    if (!this.data || !this.data.approve_result) return true
    return this.data.approve_result == 'REJECT'
  }

  private get isYqxyyReject() {
    if (!this.data || !this.data.approve_result) return true
    return this.data.approve_result == 'REJECT'
  }

  private get displayApproveReason() {
    if (!this.data || !this.data.approve_reason) return ''
    return this.data.approve_reason
  }

  private get displayTime() {
    if (this.data.timestamp.deal_at) {
      return this.data.timestamp.deal_at
    } else {
      if (!this.data || !this.data.finish_at) return ''
      return this.data.finish_at
    }
  }

  private get displaySensitiveWords() {
    return this.data && (this.data.sensitive_words || []).map((item) => item.name).join(', ')
  }

  // 家长大学特有字段

  private get isJzdx() {
    return jzdx.isJzdx(this.parentInstance)
  }

  private get jzdxTopic() {
    return jzdx.get_jzdxTopic(this.parentInstance)
  }
  private get jzdxUserId() {
    return jzdx.get_jzdxUser(this.parentInstance)
  }
  private get jzdxCommentTime() {
    return jzdx.get_jzdxTime(this.parentInstance)
  }
  private get jzdxCommentStand() {
    return jzdx.get_jzdxStand(this.parentInstance)
  }
  private get jzdxCommentContent() {
    return jzdx.get_jzdxComment(this.parentInstance)
  }
  private get jzdxSensitiveType() {
    if (!this.data.sensitive_contents || this.data.sensitive_contents.length == 0) return ''
    return this.data.sensitive_contents[0].sensitive_type_text || ''
  }
  // 家长大学特有字段 end

  // 一起学运营特有字段
  private get isYqxyy() {
    return yqxyy.isYqxyy(this.parentInstance)
  }
  private get yqxyyUserId() {
    return yqxyy.get_yqxyyUser(this.parentInstance)
  }
  private get yqxyyCreatedAt() {
    return yqxyy.get_createdAt(this.parentInstance)
  }
  private get yqxyyIdiom() {
    return yqxyy.get_yqxyyIdiom(this.parentInstance)
  }
  private get yqxyyRejectReason() {
    // return yqxyy.get_yqxyyRejectReason(this.data)

    return null
  }
  // 一起学运营特有字段 end

  // 松果AI课
  private get isSongguo() {
    return SongGuo.isSongguo(this.parentInstance)
  }

  private get songguoCategory() {
    return SongGuo.songguoCategory(this.parentInstance)
  }

  private get isSongguoReject() {
    if (!this.data || !this.data.approve_result) return true
    return this.data.approve_result == 'REJECT'
  }
  // 松果AI课 end

  // GR 直播大讲堂
  private get isGR() {
    return GR.isGR(this.parentInstance)
  }

  private get isGRReject() {
    if (!this.data || !this.data.approve_result_text) return false
    return this.data.approve_result_text == '驳回'
  }

  // 自媒体
  private get isWeMedia() {
    return weMedia.isWeMedia(this.parentInstance)
  }
  private get isWeMediaReject() {
    if (!this.data || !this.data.approve_result_text) return false
    return this.data.approve_result_text == '驳回'
  }
  // 自媒体 / 账号名称
  private get weMediaAccountName() {
    return weMedia.get_weMediaAccountName(this.parentInstance)
  }
  // 自媒体 / 分类
  private get weMediaCategoryName() {
    return weMedia.get_weMediaCategoryName(this.parentInstance)
  }
  // 自媒体 / 业务方
  private get weMediaSourceName() {
    return weMedia.get_weMediaSourceName(this.parentInstance)
  }
  // 自媒体 / 上传人
  private get weMediaCreator() {
    return weMedia.get_weMediaCreator(this.parentInstance)
  }
  // 自媒体 / 业务负责人
  private get weMediaOperator() {
    return weMedia.get_weMediaOperator(this.parentInstance)
  }
  // 自媒体 / 预计发布日期
  private get weMediaPublishAt() {
    return weMedia.get_weMediaPublishAt(this.parentInstance)
  }
  // 自媒体 / 内容标题
  private get weMediaTitle() {
    return weMedia.get_weMediaTitle(this.parentInstance)
  }
  // 自媒体 / 驳回附件
  private get weMediaAttachment() {
    return this.data.resource.qiyuan_approve_attachment
  }

  // 广告
  private get isAd() {
    return ad.isAd(this.parentInstance)
  }

  private get isAdReject() {
    if (!this.data || !this.data.approve_result_text) return false
    return this.data.approve_result_text == '驳回'
  }

  private get isUpgrade() {
    if (!this.data || !this.data.approve_result) return false
    return this.data.approve_result === 'UPGRADE'
  }

  private get isAdTerminated() {
    if (!this.data || !this.data.approve_result_text) return false
    return this.data.approve_result_text == '终止'
  }
  private get subjectName() {
    if (!this.data || !this.data.resource || !this.data.resource.subject_name) return ''
    return this.data.resource.subject_name
  }
  private get subjectID() {
    if (!this.data || !this.data.resource || !this.data.resource.subject_id) return ''
    return this.data.resource.subject_id
  }
  private get instanceID() {
    return this.data && this.data.resource && this.data.resource.instance_id
  }
  // 素材说明
  private get resourceCopyright() {
    return this.data && this.data.resource && this.data.resource.copyright
  }
  // 文件类型判断
  public resourceType(data) {
    return ResourceType(data)
  }
  // 任务转办流程
  private get isFlow() {
    if (!this.data || !this.data.name) return ''
    return this.data.name === '任务转办'
  }
  private get transferToName() {
    if (!this.data || !this.data.transfer_to_name) return ''
    return this.data.transfer_to_name
  }
  // 轻课start
  private get isQk() {
    return qk.isQk(this.parentInstance)
  }
  private get isQkReject() {
    if (!this.data || !this.data.approve_result_text) return false
    return this.data.approve_result_text == '拒绝'
  }
  private get qkUserName() {
    return (
      this.parentInstance &&
      this.parentInstance.resource &&
      this.parentInstance.resource.extras &&
      this.parentInstance.resource.extras.username
    )
  }
  private get qkUserPic() {
    return (
      this.parentInstance &&
      this.parentInstance.resource &&
      this.parentInstance.resource.extras &&
      this.parentInstance.resource.extras.avatar
    )
  }
  private get qkContentTitle() {
    return (
      this.parentInstance &&
      this.parentInstance.resource &&
      this.parentInstance.resource.extras &&
      this.parentInstance.resource.extras.title
    )
  }
  private get qkShareUrl() {
    return (
      this.parentInstance &&
      this.parentInstance.resource &&
      this.parentInstance.resource.extras &&
      this.parentInstance.resource.extras.share_url
    )
  }
  // 拒绝
  private get qkRejectReason() {
    return this.data && this.data.approve_reason
  }
  private get qkApproveReason() {
    return this.data && this.data.detail
  }
  // 轻课end
}
